import React, { useContext, useEffect, useState } from 'react'
import { useLanguage } from '../../../components/context/LanguageContext'
import { Button, Tabs, notification } from 'antd'
import { Content } from 'antd/es/layout/layout'
import LicitatiiStatusTab from './LicitatiiStatusTab'
import LicitatiiStorageTab from './LicitatiiStorageTab'
import LicitatiiCentralizatorTab from './LicitatiiCentralizatorTab'
import { apiRequest } from '../../../helpers'
import { AuthorizationContext } from '../../../components'

const LicitatiiDetails = ({ agent, refreshData }) => {
  const languageContext = useLanguage()
  const [activeTabKey, setActiveTabKey] = useState('0')
  const [tabs, setTabs] = useState([])
  const { userData } = useContext(AuthorizationContext)
  const [processing, setProcessing] = useState(false)

  useEffect(() => {
    setTabs(getInitialTabs())
    setActiveTabKey('0')
  }, [agent.id, agent.processCentralizatorDocuments, userData.language])

  const startProcessing = async () => {
    console.log('Starting processing for agent:', agent)
    setProcessing(true)
    try {
      const result = await apiRequest(process.env.REACT_APP_API + `agents/licitatii/${agent.id}/start`, 'POST', {})

      if (!result.ok) {
        notification.error({
          message: languageContext.t('Error'),
          description: languageContext.t(result.data?.message || 'Failed to start processing'),
        })
        return
      }

      notification.success({
        message: languageContext.t('Success'),
        description: languageContext.t('Processing started successfully'),
      })

      if (refreshData) {
        refreshData(Date.now())
      }
    } catch (error) {
      console.error('[ERROR] Problem starting processing!', error)
      notification.error({
        message: languageContext.t('Error'),
        description: languageContext.t('Failed to start processing'),
      })
    }
    setProcessing(false)
  }

  const stopProcessing = async () => {
    setProcessing(true)
    try {
      const result = await apiRequest(process.env.REACT_APP_API + `agents/licitatii/${agent.id}/stop`, 'POST', {})

      if (!result.ok) {
        notification.error({
          message: languageContext.t('Error'),
          description: languageContext.t(result.data?.message || 'Failed to stop processing'),
        })
        return
      }

      notification.success({
        message: languageContext.t('Success'),
        description: languageContext.t('Processing stopped successfully'),
      })

      if (refreshData) {
        refreshData(Date.now())
      }
    } catch (error) {
      console.error('[ERROR] Problem stopping processing!', error)
      notification.error({
        message: languageContext.t('Error'),
        description: languageContext.t('Failed to stop processing'),
      })
    }
    setProcessing(false)
  }

  const getInitialTabs = () => {
    const baseTabs = [
      {
        label: `${languageContext.t('Status')}`,
        children: (
          <Content>
            <LicitatiiStatusTab
              agent={agent}
              onStartProcessing={startProcessing}
              onStopProcessing={stopProcessing}
              processing={processing}
              refreshData={refreshData}
            />
          </Content>
        ),
        key: '0',
        closable: false,
      },
    ]

    // Add appropriate second tab based on processCentralizatorDocuments setting
    if (agent.processCentralizatorDocuments) {
      baseTabs.push({
        label: <span>📂 {languageContext.t('Centralizator')}</span>,
        children: (
          <Content>
            <LicitatiiCentralizatorTab agent={agent} refreshData={refreshData} />
          </Content>
        ),
        key: '1',
        closable: false,
      })
    } else {
      baseTabs.push({
        label: `${languageContext.t('Storage')}`,
        children: (
          <Content>
            <LicitatiiStorageTab agent={agent} refreshData={refreshData} />
          </Content>
        ),
        key: '1',
        closable: false,
      })
    }

    return baseTabs
  }

  return <Tabs className="mt-3" type="card" activeKey={activeTabKey} onChange={key => setActiveTabKey(key)} items={tabs} />
}

export default LicitatiiDetails
